import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as OnlineContractActions from '../actions/online-contract.actions';
import * as OnlineContractSelectors from '../selectors/online-contract.selectors';
import { SigningData } from '../../online-contract.service';
import { RecipientRole } from 'app/main/pages/edit-template/edit-template.dto';

@Injectable({
    providedIn: 'root',
})
export class OnlineContractFacade {
    getOnlineContract$ = this.store.select(OnlineContractSelectors.selectOnlineContract);
    signOnlineContractRequestState$ = this.store.select(OnlineContractSelectors.selectSignOnlineRequestState);
    signOnlineContractErrorCode$ = this.store.select(OnlineContractSelectors.selectSignOnlineErrorCode);
    selectSendOnlineInvitationRequestState$ = this.store.select(OnlineContractSelectors.selectSendOnlineInvitationRequestState);
    visitedRoles$ = this.store.select(OnlineContractSelectors.selectVisitedRecipientRoles);

    constructor(private store: Store) { }

    getOnlineContract(template_id:number, uuid: string) {
        this.store.dispatch(OnlineContractActions.getOnlineContract(template_id, uuid));
    }

    signOnlineContract(data: SigningData, template_id: number) {
        this.store.dispatch(OnlineContractActions.signOnlineContract(data, template_id));
    }

    sendOnlineContractInvitation(data: SigningData, template_id: number) {
        this.store.dispatch(OnlineContractActions.sendInvitation(data, template_id));
    }

    addVisitedRole(role: RecipientRole[]) {
        this.store.dispatch(OnlineContractActions.addVisitedRecipientRole({role}));
    }

    updateVisitedRole(updatedRole: RecipientRole) {
        this.store.dispatch(OnlineContractActions.updateVisitedRecipientRole({ updatedRole }));
    }
}
